<main class="container-main-process">
  <section class="section-img-process">
    <img src="/assets/images/logos/dark-logo.png" style="width: 50%;" alt="" />
  </section>
  <section class="container-process">
      <h1>Estamos validando tus datos</h1>
      <h2>Por Favor Espera ...</h2>
      <mat-spinner></mat-spinner>
  </section>
</main>
